import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value", "style", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"];
import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
import NumberTypes from '../constants/NumberTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedNumber(t0) {
  const $ = _c(3);
  const {
      abbreviate,
      abbreviateThreshold,
      value,
      style: t1,
      simplifyCurrency: t2,
      stripInsignificantZeros: t3,
      useCurrencyCode
    } = t0,
    options = _objectWithoutPropertiesLoose(t0, _excluded);
  const style = t1 === undefined ? NumberTypes.DECIMAL : t1;
  const simplifyCurrency = t2 === undefined ? false : t2;
  const stripInsignificantZeros = t3 === undefined ? true : t3;
  useContext(I18nHMRContext);
  const NUMBER_FORMATTERS = {
    [NumberTypes.DECIMAL]: I18n.formatNumber,
    [NumberTypes.CURRENCY]: I18n.formatCurrency,
    [NumberTypes.PERCENTAGE]: I18n.formatPercentage
  };
  const numberFormatter = NUMBER_FORMATTERS[style];
  if (style === NumberTypes.CURRENCY) {
    console.warn("Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.");
  }
  if (simplifyCurrency && value % 1 === 0) {
    options.precision = 0;
  }
  if (useCurrencyCode) {
    options.unit = "";
  }
  if (stripInsignificantZeros === false) {
    options.strip_insignificant_zeros = false;
  } else {
    options.strip_insignificant_zeros = true;
  }
  let title = undefined;
  if (abbreviate && (typeof abbreviateThreshold !== "number" || typeof abbreviateThreshold === "number" && value >= abbreviateThreshold)) {
    title = numberFormatter(value, options);
    options.abbreviate = true;
    options.precision = 0;
  }
  const formattedNumber = numberFormatter(value, options);
  const numberToRender = useCurrencyCode ? formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
  let t4;
  if ($[0] !== numberToRender || $[1] !== title) {
    t4 = /*#__PURE__*/_jsx("span", {
      title: title,
      children: numberToRender
    });
    $[0] = numberToRender;
    $[1] = title;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}
FormattedNumber.displayName = 'FormattedNumber';
export default FormattedNumber;